import { render } from "./StoragePoolSelectView.vue?vue&type=template&id=3a803237&scoped=true"
import script from "./StoragePoolSelectView.vue?vue&type=script&lang=js"
export * from "./StoragePoolSelectView.vue?vue&type=script&lang=js"

import "./StoragePoolSelectView.vue?vue&type=style&index=0&id=3a803237&scoped=true&lang=scss"

import exportComponent from "/home/biktorgj/Projects/Linube Cloud/Server_and_UI/ui-prod-4.22/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a803237"]])

export default __exports__